/** Distinguish unavailable rates from transport, provider and session failures. */
export function isExpiredPricingError(error: unknown): boolean {
  const details = error as {
    extensions?: { code?: string };
    graphQLErrors?: readonly unknown[];
    message?: string;
  } | null;
  if (details?.graphQLErrors?.some(isExpiredPricingError)) return true;
  if (details?.extensions?.code === 'BUSINESS_RATE_UNAVAILABLE') return true;

  // Handle Error objects or strings
  const errorMessage =
    typeof error === 'string'
      ? error
      : error instanceof Error
        ? error.message
        : details?.message || '';

  const expiredPricingPatterns = [
    /rate may have changed or is no longer available/i,
    /no longer available/i,
    /pricing.*expired/i,
    /rate.*expired/i,
    /offer.*not found/i,
    /no matching hotel offer found/i,
    /enhanced pricing request.*not found/i,
    /this pricing has expired/i,
  ];

  return expiredPricingPatterns.some((pattern) => pattern.test(errorMessage));
}
